export default __webpack_public_path__ + "static/media/genre.f0e1f6a3.svg";